export default function shareLink(){
    const facebookBtn = document.querySelector(".facebook");
    const linkedinBtn = document.querySelector(".linkedin");
    // const emailBtn = document.querySelector(".email-share");
    const twitterBtn = document.querySelector('.twitter');
    const wppBtn = document.querySelector('.wpp');
    if(facebookBtn == null){
        console.log('no share')
    } else{
      let linkPage = window.location.href;
      let postUrl = encodeURI(linkPage);
      // console.log(postUrl);

      const shareData = {
        title: 'Panniz',
        text: 'Olá pessoal, olhe esse post!!',
        url: `${postUrl}`
      }
      // Share must be triggered by "user activation"
    //   emailBtn.addEventListener('click', async () => {
    //     try {
    //       await navigator.share(shareData)
    //       console.log('funfou')
    //     } catch(err) {
    //       console.log(err)
    //     }
    //   });


      // let postUrl = encodeURI(document.location.href);
      let postTitle = encodeURI("Olá pessoal, olhe esse post!!");
      facebookBtn.setAttribute(
        "href",
        `https://www.facebook.com/sharer.php?u=${postUrl}`
      );
      linkedinBtn.setAttribute(
        "href",
        `https://www.linkedin.com/shareArticle?url=${postUrl}&title=${postTitle}`
      );
      wppBtn.setAttribute(
          "href",
          `https://wa.me/?text=${postUrl}`
      );
      twitterBtn.setAttribute(
        "href",
        `https://twitter.com/intent/tweet?url=${postUrl}&text=${postTitle}`
        );
    }


  }
